/* Compatibility glue. The original theme scripts remain unmodified. */
(() => {
  const legacySelector='.shopify-section:not(.fn-shopify-section)';
  const isLegacy=node=>node instanceof Element && !!node.closest(legacySelector);
  const markPortals=()=>document.querySelectorAll('body > modal-dialog,body > product-modal,body > quick-add-modal,body > media-modal').forEach(node=>node.classList.add('fn-legacy-portal'));
  markPortals();
  new MutationObserver(markPortals).observe(document.body,{childList:true});
  const settings=window.fnLegacySettings||{};
  let observer;
  if(settings.animations && 'IntersectionObserver' in window){
    const sticky=document.querySelector('.sticky-atc');
    observer=new IntersectionObserver(entries=>entries.forEach(entry=>{
      if(entry.isIntersecting)entry.target.classList.add('animate--shown');
      else if(settings.repeatAnimations)entry.target.classList.remove('animate--shown');
    }),{rootMargin:`0px 0px -${50+(sticky?.clientHeight||0)}px 0px`});
  }
  function initialize(root=document,editor=false){
    root.querySelectorAll('.animate-section').forEach(node=>{
      if(!isLegacy(node))return;
      if(editor)node.classList.add('animate--shown');else observer?.observe(node);
    });
    root.querySelectorAll('[id^="SectionAtcBtn-"]').forEach(button=>{
      if(!isLegacy(button)||button.dataset.fnLegacyBound)return;
      button.dataset.fnLegacyBound='true';
      button.addEventListener('click',event=>{
        const original=document.querySelector('product-form[data-main="true"]');
        if(original?.handleSubmit){original.handleSubmit(event);return;}
        const native=document.querySelector('[data-fn-product] [data-fn-add]');
        if(native){event.preventDefault();native.click();}
      });
    });
    markPortals();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initialize());else initialize();
  document.addEventListener('shopify:section:load',event=>initialize(event.target,true));
  document.addEventListener('shopify:section:reorder',()=>initialize(document,true));
})();
